import React from 'react'
import AllMenu from '../common/AllMenu';
// import { SearchSvg } from '../../svgFile';
import { Link, useNavigate } from 'react-router-dom';

const DesktopHeader = ({count=0}) => {
  const navigate = useNavigate();
    const token = localStorage.getItem("accessToken");
  return (
    <header className='desktop-header d-none d-xl-block'>
           <nav className="navbar navbar-expand-xl ">
        <div className="container ">
        <div className='desktop-logo' onClick={(()=>navigate("/"))} style={{cursor:"pointer"}}>
            <img src="/image/logo.png" alt="" />
        </div>
      
          <AllMenu count={count}/>
              <div className="d-flex align-items-center gap-2">
           
            {/* <button className="navbar-toggler toggler-btn position-relative d-flex">
            <SearchSvg/>
  
            </button> */}
             {token && <button className="navbar-toggler toggler-btn position-relative d-flex" onClick={(()=> navigate("/notification"))}>
              <img src="/image/bell.svg" alt="" />
              <div className="notification-dot">{count}</div>
            </button>}
            <Link to="/contact" className='btn theme-btn'>Contact Us</Link>
          </div>
        </div>
      </nav>
            <div className="shape"></div>
    </header>
  )
}

export default DesktopHeader;